import React from 'react';
import { Tag, Space, Button } from 'antd';
import { ClearOutlined } from '@ant-design/icons';
import { useQuery } from '@apollo/client';
import { SEARCH_TAGS } from '../../mutations/tags';

const fieldLabels = {
  'tags': 'Tags',
  'name': 'Nome',
  'nickname': 'Apelido',
  'document': 'Documento',
  'whatsapp': 'WhatsApp',
  'phone': 'Telefone',
  'observation': 'Observação',
  'mainContact': 'Contato Principal',
  'reference': 'Código',
  'stateRegistration': 'Inscrição Estadual',
  'city': 'Cidade',
  'state': 'Estado',
  'active': 'Status'
};

const operatorLabels = {
  'contains': 'contém',
  'not_contains': 'não contém',
  'equals': 'é exatamente',
  'is_empty': 'está em branco',
  'is_not_empty': 'está preenchido',
  'is_empty_array': 'está vazio',
  'is_not_empty_array': 'não está vazio',
  'is_active': 'ativo',
  'is_inactive': 'inativo',
  'both': 'todos',
  'whatsapp_verified': 'validado',
  'whatsapp_not_verified': 'não validado'
};

const getFilterLabel = (filter, tags = []) => {
  const fieldLabel = fieldLabels[filter.field] || filter.field;
  const operatorLabel = operatorLabels[filter.operator] || filter.operator;
  
  // Para operadores que não precisam de valor
  if (['is_empty', 'is_not_empty', 'is_active', 'is_inactive', 'both', 'whatsapp_verified', 'whatsapp_not_verified'].includes(filter.operator)) {
    return `${fieldLabel} ${operatorLabel}`;
  }
  
  let valueText = '';
  
  if (filter.field === 'tags' && Array.isArray(filter.value)) {
    // Buscar nomes das tags pelos IDs
    const selectedTags = tags.filter(tag => filter.value.includes(tag.id));
    valueText = selectedTags.map(tag => tag.name).join(', ');
  } else if (Array.isArray(filter.value)) {
    valueText = filter.value.join(', ');
  } else {
    valueText = filter.value?.toString() || '';
  }
  
  if (valueText.length > 30) {
    valueText = valueText.substring(0, 30) + '...';
  }
  
  return `${fieldLabel} ${operatorLabel} "${valueText}"`;
};

const ActiveAdvancedFilters = ({ filters, onRemoveFilter, onClearAll, style = {} }) => {
  // Buscar tags para converter IDs em nomes
  const { data: tagsData } = useQuery(SEARCH_TAGS, {
    variables: { query: '*' }, // Buscar todas as tags
    skip: !filters.some(f => f.field === 'tags')
  });
  
  const tags = tagsData?.searchTags || [];

  if (!filters || filters.length === 0) {
    return null;
  }

  return (
    <div style={{ marginBottom: 16, ...style }}>
      <Space wrap size={[8, 8]}>
        <span style={{ fontWeight: 500, color: '#666' }}>Filtros avançados:</span>
        {filters.map((filter, index) => (
          <Tag
            key={`${filter.id}-${index}`}
            closable
            onClose={() => onRemoveFilter(index)}
            color="blue"
            style={{
              margin: '2px',
              padding: '4px 8px',
              borderRadius: '6px',
              display: 'flex',
              alignItems: 'center',
              maxWidth: '300px'
            }}
          >
            <span style={{ 
              overflow: 'hidden', 
              textOverflow: 'ellipsis', 
              whiteSpace: 'nowrap',
              fontSize: '12px'
            }}>
              {getFilterLabel(filter, tags)}
            </span>
          </Tag>
        ))}
        {filters.length > 1 && (
          <Button
            size="small"
            type="text"
            icon={<ClearOutlined />}
            onClick={onClearAll}
            style={{ 
              color: '#ff4d4f',
              fontSize: '12px',
              padding: '2px 6px',
              height: 'auto'
            }}
          >
            Limpar todos
          </Button>
        )}
      </Space>
    </div>
  );
};

export default ActiveAdvancedFilters;